class ArticleCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.article-modular__carousel-track');
    this.slides = container.querySelectorAll('.article-modular__carousel-slide');
    this.dots = container.querySelectorAll('.article-modular__carousel-dot');
    this.prevButton = container.querySelector('.article-modular__carousel-arrow--prev');
    this.nextButton = container.querySelector('.article-modular__carousel-arrow--next');
    
    this.currentSlide = 0;
    this.slideCount = this.slides.length;
    
    this.init();
  }
  
  init() {
    if (this.slideCount <= 1) {
      // Hide navigation if only one slide
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      this.container.querySelector('.article-modular__carousel-dots').style.display = 'none';
      return;
    }
    
    this.updateDots();
    this.bindEvents();
  }
  
  bindEvents() {
    this.prevButton.addEventListener('click', () => this.prevSlide());
    this.nextButton.addEventListener('click', () => this.nextSlide());
    
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Keyboard navigation
    this.container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.nextSlide();
      }
    });
    
    // Touch/swipe support
    let startX = 0;
    let endX = 0;
    
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });
    
    this.container.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      this.handleSwipe(startX, endX);
    });
  }
  
  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }
  }
  
  prevSlide() {
    this.currentSlide = this.currentSlide === 0 ? this.slideCount - 1 : this.currentSlide - 1;
    this.updateCarousel();
  }
  
  nextSlide() {
    this.currentSlide = this.currentSlide === this.slideCount - 1 ? 0 : this.currentSlide + 1;
    this.updateCarousel();
  }
  
  goToSlide(index) {
    this.currentSlide = index;
    this.updateCarousel();
  }
  
  updateCarousel() {
    const translateX = -this.currentSlide * 100;
    this.track.style.transform = `translateX(${translateX}%)`;
    this.updateDots();
  }
  
  updateDots() {
    this.dots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
}

// Initialize all carousels when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.article-modular__carousel');
  carousels.forEach(carousel => new ArticleCarousel(carousel));
}); 